export const enum PropertySavedStatechartStoreEvent {
  save = 'save',
  unsave = 'unsave',
  saveFailure = 'saveFailure',
  unsaveFailure = 'unsaveFailure',
  saveSuccess = 'saveSuccess',
  unsaveSuccess = 'unsaveSuccess',

  /**
   * Reset statechart to idle state (when log out happens)
   */
  reset = 'reset',
}
